import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { clearRenderedMenu } from '../menu.provider';
import { UserDeviceTokenService } from '../proxy/user-device-tokens/user-device-token.service';
import { FirebaseMessagingService } from '../service/firebase-messaging.service';

@Injectable({ providedIn: 'root' })
export class TenantSessionService {
  constructor(
    private oauthService: OAuthService,
    private userDeviceTokenService: UserDeviceTokenService,
    private fcmService: FirebaseMessagingService,
  ) {}

  logoutCurrentOrigin(): void {
    const tenantName = localStorage.getItem('__tenant');

    console.info('[Auth] Logging out current origin only', {
      origin: window.location.origin,
      tenantName,
      timestamp: new Date().toISOString(),
    });

    clearRenderedMenu();

    const finishLogout = () => {
      this.oauthService.logOut(true);

      const loginUrl = new URL('/account/login', window.location.origin);
      if (window.location.hostname === 'localhost' && tenantName) {
        loginUrl.searchParams.set('__tenant', tenantName);
      }

      window.location.replace(loginUrl.toString());
    };

    const token = this.fcmService.getCurrentToken();
    if (token) {
      this.userDeviceTokenService.deactivateToken(token).subscribe({
        next: finishLogout,
        error: finishLogout,
      });
    } else {
      finishLogout();
    }
  }
}
